import { api } from '../api.ts'
import { useBusy } from '../lib/hooks.ts'
import { toast, toastError } from '../toast.ts'
import { Button } from './ui.tsx'

type State = 'active' | 'draining' | 'paused'

/** The server owns these states; a heartbeat or daemon restart cannot undo a pause. */
export function FleetControls({ path, state, name, onChanged }: {
  path: string
  state: State
  name: string
  onChanged: () => void
}) {
  const [busy, run] = useBusy()
  const change = (next: State) => void run(async () => {
    try {
      await api.patch(path, { state: next })
      toast(next === 'active' ? `${name}: работа разрешена` : next === 'draining'
        ? `${name}: новые ходы передаются другим раннерам, текущие завершаются`
        : `${name}: пауза; текущие ходы передаются после остановки`, 'success')
      onChanged()
    } catch (e) { toastError(e, 'Не удалось изменить состояние') }
  })
  return <div className="flex flex-wrap gap-2" role="group" aria-label={`Управление: ${name}`}>
    {state !== 'active' ? <Button size="sm" icon="play" disabled={busy} onClick={() => change('active')}>Возобновить</Button> : null}
    {state === 'active' ? <Button size="sm" disabled={busy} onClick={() => change('draining')}
      title="Не брать новые ходы; текущие завершить на этом раннере">Завершить ходы и пауза</Button> : null}
    {state !== 'paused' ? <Button size="sm" icon="pause" disabled={busy} onClick={() => change('paused')}
      title="Остановить текущие ходы и передать работу доступным раннерам с восстановлением контекста">Пауза и передача</Button> : null}
  </div>
}
